module.exports = __webpack_public_path__ + "img/close.06afbe18.svg";